import image1 from "./team-members-images/kanchonKantiPodder.JPG";
import image2 from "./team-members-images/farhanFuadAbir.JPG";
import image3 from "./team-members-images/promaDutta.jpg";
import image4 from "./team-members-images/malishaIslamTapotee.jpg";
import image5 from "./team-members-images/promitBasak.jpg";
import image6 from "./team-members-images/moajjem.JPG";
import image7 from "./team-members-images/alveeHassan.jpg";
import image8 from "./team-members-images/muntakimMahmudKhan.jpg";
import image9 from "./team-members-images/moumitaBarua.jpg";
import image10 from "./team-members-images/muttakee.jpg";
import image11 from "./team-members-images/arafatRahman.jpg";
import image12 from "./team-members-images/faizulRakibSayem.jpg";
import image13 from "./team-members-images/tosifulIslam.png";
import image14 from "./team-members-images/sumon.png";
import image15 from "./team-members-images/mdShafayetHossain.jpg";
import image16 from "./team-members-images/mdMohiuddinSoliman.jpg";
import image17 from "./team-members-images/mdMamunSheikh.png";
import image18 from "./team-members-images/nazmul.jpg";
import image19 from "./team-members-images/mdJubairAhmedSourov.jpg";
import image20 from "./team-members-images/dewanImranAhmed.jpg";
import image21 from "./team-members-images/mdAhasanAtickFaisal.jpg";
import image22 from "./team-members-images/sakibMahmud.jpg";
import image23 from "./team-members-images/tawsifurRahman.jpg";
import image24 from "./team-members-images/mohamedAbdelmoniem.png";
import image25 from "./team-members-images/tasmirAhmed.jpg";
import image26 from "./team-members-images/zakariaShamsSiam.jpg";
import image27 from "./team-members-images/purnataSaha.jpg";
import image28 from "./team-members-images/amithKhandakar.jpg";
import image29 from "./team-members-images/ahmNazmusSakib.jpg";
import image30 from "./team-members-images/johayraPrithula.jpeg";
import image31 from "./team-members-images/saidulKabir.jpg";
import image32 from "./team-members-images/srimanBidhanBaray.jpg";
import image33 from "./team-members-images/naimaNisha.jpg";
import image34 from "./team-members-images/enamul.jpg";
import image35 from "./team-members-images/farhanaAhmed.jpeg";
import image36 from "./team-members-images/jawadHabib.JPG";
import image37 from "./team-members-images/mohammadKaosarAlam.jpg";

import emptyImage from "./team-members-images/emptyProfilePic.png";

const listOfTeamMembers = [
  {
    id: 1,
    name: "Kanchon Kanti Podder",
    member: "current",
    role: "researcher",
    subrole: "full time",
    image: image1,
    contact: "Kanchon.k.podder@bmpt.du.ac.bd",
    linkedIn: "https://www.linkedin.com/in/kanchon-kanti-podder-132864122/",
    personalWebsite: "https://sites.google.com/view/kanchon-kanti-podder/",
    googleScholar:
      "https://scholar.google.com/citations?user=TlXogwEAAAAJ&hl=en&oi=ao",
    details: `Hello! I am Kanchon Kanti Podder, a University of Dhaka graduate in Biomedical Physics and Technology (Specialization in Biomedical Engineering). I earned my B.Sc in Electrical and Electronic Engineering from the Chittagong University of Engineering Technology. The "Question-Answer'' motif has piqued my curiosity. For example, I try to find solutions to challenges that Artificial Intelligence and Computer Vision can tackle. With that drive, I started working as a Research Assistant at the "Qatar University Machine Learning Group (QUML Group)" in July 2021, although I started working with Dr. MUHAMMAD E. H. CHOWDHURY in late 2019. With QUML group, I've been working on constructing an AI-powered end-to-end sign language transformer that can convert a sign language user to a non-sign language user and vice versa. I've published several papers on the recognition of dynamic and static Bangla and Arabic sign languages. I was recently involved in "AI-based Diabetic Neuropathy Solution Using Corneal Confocal Microscopy." I also have one year of experience working in the Automated Biomedical Devices industry. I was able to build skills in Python and MATLAB throughout my academic and professional career. Know me more and my research work from my website, google scholar and other platforms.`,
  },
  {
    id: 2,
    name: "Farhan Fuad Abir",
    member: "lab_alumni",
    role: "researcher",
    subrole: "full time",
    image: image2,
    contact: "farhan.fuad@ieee.org",
    linkedIn: "https://www.linkedin.com/in/farhanfuadabir/",
    personalWebsite: "https://ffabir.com/",
    github: "https://github.com/farhanfuadabir",
    details: `Farhan Fuad Abir received his Bachelor of Science degree in Electrical and Electronic Engineering from the University of Dhaka, Bangladesh in 2020. His research lies at the intersection of Embedded Systems and Applied Machine Learning.
          Farhan's undergraduate project was a sensor-based hand gesture recognition system involving both Embedded Systems and Applied ML. After graduation, he worked in the R&D division of Datasoft Manufacturing and Assembly Inc. as a Biomedical Engineer. 
          Farhan joined the Qatar University Machine Learning Group in August 2021. In the group, he worked on a wearables-based presymptomatic COVID-19 detection project and developed a deep learning pipeline for anomaly detection. Additionally, he worked on the IoT-enabled automated IV dispenser system for burn patients.
          Farhan will start his Ph.D. in Computer Engineering at the University of Central Florida under the supervision of Dr. Ying Ma in Fall 2022.`,
  },
  {
    id: 3,
    name: "Proma Dutta",
    member: "current",
    role: "researcher",
    subrole: "full time",
    image: image3,
    contact: "proma.cuet.11@gmail.com",
    linkedIn: "https://www.linkedin.com/in/proma-dutta-334157137",
    cv: "https://drive.google.com/file/d/1CRlX8QEyUSi2wD9YamHCEWnKwPd3QEzP/view?usp=sharing",
    details: `Hello! I am Proma Dutta, graduated from Chittagong University of Engineering and Technology (CUET) with a BSc degree in Electrical and Electronic Engineering. I started working with Qatar University Machine Learning Group in January 2022. My research interest focused on Biomedical Signal Processing and Deep Learning. As a beginner in this group, I was responsible for the project on gearbox fault detection using deep learning. Currently, I am working on Fetal Arrhythmia detection using FECG. You can find my updated information in my CV and LinkedIn profile.`,
  },
  {
    id: 4,
    name: "Malisha Islam Tapotee",
    member: "current",
    role: "researcher",
    subrole: "volunteer researcher",
    image: image4,
    contact: "malishatapotee@gmail.com",
    linkedIn: "https://www.linkedin.com/in/malishaislamtapotee/",
    github: "https://github.com/MalishaIslam",
    details:
      "This is Malisha Islam Tapotee is currently a senior student of Dept. of EEE, University of Dhaka, Bangladesh. My interest in the vast field of  Data Science has grown up after participating in some national and international Data Science Competition like ‘Ada Lovelace Datathon, Sussex-Huawei Locomotion Challenge. Now I am working in the Biomedical engineering field of Data Science. I did an internship in Datasoft Manufacturing & Assembly Limited for 6 months on an IoT-based project. I have some prior knowledge in MATLAB and the programming language Python. Besides my academic part, I like to do voluntary work. I am the current chair of IEEE Student Branch University of Dhaka.",
  },
  {
    id: 5,
    name: "Promit Basak",
    member: "current",
    role: "researcher",
    subrole: "full time",
    image: image5,
    contact: "basakpromit@gmail.com",
    linkedIn: "https://www.linkedin.com/in/promitbasak/",
    github: "https://github.com/promitbasak",
    details:
      "Promit Basak is currently an undergraduate student in the Department of Electrical and Electronic Engineering at the University of Dhaka. His primary research interests are human activity recognition, healthcare technologies, signal processing, and computer vision. Before joining Qatar University Machine Learning Group, he worked as a backend developer in different software companies. He achieved several national and international prizes in competitions like Blockchain Olympiad Bangladesh, Bento Packaging Activity Recognition Challenge, Techkriti ML Hackathon, and Nurse Care Activity Recognition Challenge.",
  },
  {
    id: 6,
    name: "Moajjem Hossain Chowdhury",
    member: "current",
    role: "researcher",
    subrole: "full time",
    altRole: "student",
    altSubrole: "MSc Student",
    image: image6,
    contact: "moajjem04@gmail.com",
    linkedIn: "https://www.linkedin.com/in/moajjem-hossain/",
    details:
      "Moajjem Hossain Chowdhury received his B.Sc. in Electrical and Electronics Engineering at North South University, Bangladesh. He is currently pursuing M.Sc. in Universiti Kebangsaan Malaysia (UKM). His current research interest includes biomedical signal processing, machine learning and computer vision. He has already worked on multiple academic publications that focus on applying ML techniques to estimate health metrics such as blood pressure from biomedical signals. He placed in the top 30 in Bangladesh Physics Olympiad 2014.",
  },
  {
    id: 7,
    name: "Alvee Hassan",
    member: "current",
    role: "researcher",
    subrole: "full time",
    image: image7,
    contact: "alveehassan.x@gmail.com",
    linkedIn: "https://www.linkedin.com/in/alvee-hassan-b47b19200",
    details: `Alvee Hassan is currently pursuing M.Sc. in Biomedical Physics & Technology from University of Dhaka. He completed his B.Sc. in Biomedical Engineering degree from Military Institute of Science & Technology in 2021. His research interest involves Computational Fluid Dynamics (CFD). He has performed his undergraduate thesis on this domain, analyzing patient specific cerebral aneurysm. Alvee joined Qatar University Machine Learning Group in June 2022 and is intrigued to explore the field of machine learning with the team.`,
  },
  {
    id: 8,
    name: "Muntakim Mahmud khan",
    member: "current",
    role: "student",
    subrole: "",
    altRole: "student",
    altSubrole: "MSc Student",
    image: image8,
    contact: "isitakib@gmail.com",
    linkedIn: "https://www.linkedin.com/in/akib-mahmud-a75456226/",
    details: `Muntakim Mahmud khan received his B.Sc. degree from Military Institute of Science & Technology on Biomedical Engineering. Currently he is doing M.S. on Biomedical Physics & Technology from University of Dhaka. He accomplished his undergraduate thesis on PET-CT images for calculating Standardized Uptake value by using In-House developed MATLAB code. Muntakim is working with Qatar University Machine Learning Group (QUML Group)" in June,2022. In this group,  he is currently enrolling in the stroke project as the segmentation of Intracranial Hemorrhage from CT image with Machine Learning.`,
  },
  {
    id: 9,
    name: "Moumita Barua",
    member: "current",
    role: "researcher",
    subrole: "volunteer researcher",
    image: image9,
    contact: "moumita.eee.cuet@gmail.com",
    linkedIn: "https://www.linkedin.com/in/moumita-barua-2b00a8147/",
    cv: "https://drive.google.com/file/d/1Z0ZCHSQOaCwvKbamu03lsNKgRgVuVu6K/view?usp=sharing",
    details: `Hello! I am Moumita Barua, graduated from Chittagong University of Engineering and Technology (CUET) with a BSc degree in Electrical and Electronic Engineering.I am currently working as a Lecturer at a private university of Bangladesh. I have started working with Qatar University Machine Learning Group in June 2022. My research interest is focused on Application of Machine Learning on clinical data. You can find my updated information in my CV and LinkedIn profile.`,
  },
  {
    id: 10,
    name: "Muttakee Bin Ali",
    member: "",
    role: "",
    subrole: "",
    image: image10,
    contact: "muttakeebinali041@gmail.com",
    linkedIn: "https://www.linkedin.com/in/muttakee-bin-ali-8063611aa",
    details: `I am Muttakee Bin Ali, an undergraduate student at the Military Institute of Science and Technology (MIST), where I am pursuing a degree in Biomedical Engineering. In May 2022, I joined the Machine Learning Group at Qatar University. My field of interests are neurophysiology and deep learning. Currently, I'm working on a project called TieLent that involves silent verbal interaction. `,
  },
  {
    id: 11,
    name: "Arafat Rahman",
    member: "lab_alumni",
    role: "student",
    subrole: "MSc Student",
    image: image11,
    contact: "arafatrahman108699@gmail.com",
    linkedIn: "https://www.linkedin.com/in/arafat-rahman-b4758088",
    personalWebsite: "https://arafat245.github.io/",
    details: `Arafat Rahman received his Bachelor of Science degree in Electrical and Electronic Engineering from the University of Dhaka (DU), Bangladesh 
    in 2018, and Master of Science in Biomedical Physics and Technology from same university in 2021. His research lies at the intersection of 
    Biomedical Engineering and Applied Machine Learning. Arafat's undergraduate project was a myoelectric prosthetic hand involving both Embedded Systems and Applied ML. 
    After graduation, he worked as a reaserch assistant in Fab Lab DU (a laboratory situated at the EEE department of DU). 
    Arafat joined the Qatar University Machine Learning Group in April 2021. In the group, he worked on EEG and keystroke based multimodal biometric system and also on the analysis of soothing effect 
    of favorite, relaxing music, and Quran using EEG. Additonally, he worked on the extraction of fetal 
    ECG from abdominal mother ECG. He published some journal papers on these research topics. Arafat will start his Ph.D. in Systems Engineering at the University of Virginia under the supervision of Dr. Laura Barnes in Fall 2022. `,
  },
  {
    id: 12,
    name: "Faizul Rakib Sayem",
    member: "current",
    role: "researcher",
    subrole: "volunteer researcher",
    image: image12,
    contact: "faizulrakib-2017214832@eee.du.ac.bd",
    researchGate: "https://www.researchgate.net/profile/Faizul-Sayem/",
    linkedIn: "https://www.linkedin.com/in/faizul-rakib-sayem-0a016121a/",
    details: `Faizul Rakib Sayem is currently an undergraduate student in Electrical and Electronic Engineering, University of Dhaka, Bangladesh.
    His research interests include biomedical signal processing, computer vision, human–computer interaction, wearable and ubiquitous computing, 
   artificial intelligence applications in nanophononics. He has already contributed several publications focusing on the use of machine learning
    techniques in the fields of AI healthcare, signal processing, and AI in Nanophotonics. He has won several international competitions including
    3rd Nurse Care Activity Recognition Challenge which is held as a part of Hasca Workshop in ACM UbiComp 2021. Besides, he has also achieved the 
   Best Paper Award (Bronze Edition) at 10th ICIEV, 2021. He was the Webmaster (Technical) of IEEE SBDU, in 2020.`,
  },
  {
    id: 13,
    name: "Tosiful Islam",
    member: "current",
    role: "researcher",
    subrole: "volunterr",
    image: image13,
    contact: "tosifulislam101@gmail.com",
    linkedIn: "https://www.linkedin.com/in/tosiful",
    cv: "https://drive.google.com/file/d/1MOslst6JM3ZBhv2Se9Ps7Z5WqqpVwP9Z/view?usp=drivesdk",
    github: "https://github.com/tosiful",
    details: `Tosiful Islam received a B.Sc. degree in Computer Science and Engineering from International Islamic University Chittagong, Bangladesh. He worked on machine learning algorithms, deep learning, and statistical data analysis, which have always been his primary fields of passion. He is currently working at Qatar University machine learning group. His research interests include Artificial intelligence, machine learning in electronic health record data and deep learning.`,
  },
  {
    id: 14,
    name: "Shaheenur islam Sumon",
    member: "current",
    role: "researcher",
    subrole: "volunteer researcher",
    image: image14,
    contact: "sumon3455.ms@gmail.com",
    linkedIn: "https://www.linkedin.com/in/md-shaheenur-islam-sumon-459463188/",
    personalWebsite: "https://sumon3455.netlify.app/",
    details: `Hello! 
    I am Md. Shaheenur islam Sumon, an undergraduate student at the Military Institute of Science and Technology (MIST), where I am now pursuing a degree in Biomedical Engineering. In May 2022, I joined the Machine Learning Group at Qatar University. Data Science and Deep Learning are my interests. At the moment, I'm working on a project called TieLent that involves silent verbal interaction. My CV and LinkedIn profile both have my most recent information.`,
  },
  {
    id: 15,
    name: "MD. Shafayet Hossain",
    member: "current",
    role: "researcher",
    subrole: "full time",
    altRole: "student",
    altSubrole: "MSc Student",
    image: image15,
    contact: "shafayet.iut08@gmail.com",
    linkedIn: "https://www.linkedin.com/in/md-shafayet-hossain-4b2664198/",
    details: `Md Shafayet Hossain received his B.Sc. in Electrical and Electronic Engineering from the Islamic University of Technology (IUT), Dhaka, Bangladesh. Currently, he is pursuing M.Sc. in Universiti Kebangsaan Malaysia (UKM) focusing on the removal/reduction of motion artifacts from physiological signals (especially from EEG signals) using traditional signal processing and machine learning-based methods/models. Mr. Shafayet is an active member of Qatar University Machine Learning Group (initiated and supervised by Dr. E. H. Chowdhury) from October 2020 to the present. He also worked as a Research Assistant at Qatar University under Prof. Dr. Serkan Kiranyaz from May 2021 to September 2021. He joined the Department of EEE of Bangladesh University of Business and Technology, Dhaka, Bangladesh as a Lecturer in 2015 and is currently on study leave.  His research interests include biomedical signal processing, machine learning & deep learning, bio-sensor design, green energy harvesting, and power electronics.
    `,
  },
  {
    id: 16,
    name: "MD. Mohiuddin Soliman",
    member: "current",
    role: "student",
    subrole: "PhD Student",
    altRole: "researcher",
    altSubrole: "full time",
    image: image16,
    contact: "p108446@siswa.ukm.edu.my",
    details: `Md Mohiuddin Soliman received a B.Sc. degree in Electronics and Telecommunication Engineering from International Islamic University Chittagong, Bangladesh. He is currently doing his Ph.D. in the Faculty of Engineering & Built Environment of The National University of Malaysia. He has been a teaching assistant and lab instructor for the past 3 years with the Electronics and Telecommunication Engineering Department of International Islamic University Chittagong. He is currently working as Graduate Research Assistant at The National University of Malaysia, Malaysia. He got the best paper award for presenting the paper titled " Design of 2x2 Microstrip Patch Antenna Array at 28 GHz for Millimeter Wave Communication at the 2020 IEEE International Conference on Informatics, IoT, and Enabling Technologies (ICIoT), Doha, Qatar. Qatar University. He has two articles in the renowned Q1 journal and 12 conference proceedings. His research interests include Implant design, Metamaterial Absorber, Sensor design, Antenna and wave propagation, Implantable antenna, and Mobile and wireless communications`,
  },
  {
    id: 17,
    name: "MD. Mamun Sheikh",
    member: "current",
    role: "researcher",
    subrole: "volunteer researcher",
    image: image17,
    contact: "mamunsheikhdueee52@gmail.com",
    linkedIn: "https://www.linkedin.com/in/mamun-sheikh-661b0a164",
    researchGate: "https://www.researchgate.net/profile/Md-Mamun-Sheikh",
    github: "https://github.com/MdMamunSheikh",
    details: `Md. Mamun Sheikh is currently an Electrical and Electronic Engineering undergraduate student at the University of Dhaka, Bangladesh. 
    His research fields of interest include Applied Machine Learning and Data Science. He has previously published several papers on the application of ML and AI techniques in the fields of healthcare and data science.
    He has achieved several international awards, including the 3rd Nurse Care Activity Recognition Challenge (Winner), which is part of the Hasca Workshop at ACM UbiComp 2021. 
    In addition, at the 10th ICIEV in 2021, he has achieved the Best Paper Award (Bronze Edition). On typeracer.com, he is a Type-Master (80+ WPM).
    `,
  },
  {
    id: 18,
    name: "Md. Nazmul Islam Shuzan",
    member: "current",
    role: "researcher",
    subrole: "full time",
    altRole: "student",
    altSubrole: "MSc Student",
    image: image18,
    contact: "nazmul.shuzan@northsouth.edu",
    linkedIn: "https://www.linkedin.com/in/md-nazmul-islam-shuzan-6b9a7a1a0/",
    details: `Md. Nazmul Islam Shuzan received his B.S (Eng) degree from the department of Electrical and computer Engineering at North South University, Dhaka, Bangladesh. Currently, he is pursuing M.Sc. in Universiti Kebangsaan Malaysia (UKM) and working as a Research Assistant in Qatar University Machine Learning Group (QU). His current research interest includes biomedical signal and image processing, machine learning, deep learning and computer vision.`,
  },
  {
    id: 19,
    name: "MD Jubair Ahmed Sourov",
    member: "current",
    role: "researcher",
    subrole: "full time",
    image: image19,
    contact: "sourovejubair@gmail.com",
    linkedIn: "https://linkedin.com/in/md-jubair-ahmed-sourov-a311a6119",
    details: `Passionate engineer, always motivated to learn new skills. I like to brainstorm and solve problems not only
    research but also for industry. As a robotics engineer, I have proficiency in hardware ranging from
    microcontroller-based (Arduino) to microprocessor-based (Raspberry Pi) and also software including MATLAB and
    python.`,
  },
  {
    id: 20,
    name: "Dewan Imran Ahmed",
    member: "current",
    role: "researcher",
    subrole: "volunteer researcher",
    image: image20,
    contact: "ahmed.imran.dewan@gmail.com",
    linkedIn: "https://www.linkedin.com/in/dewan-imran-ahmed-9397631a6",
    details: `Dewan Imran Ahmed, received his Bachelor of Science Degree in Biomedical Engineering from Military Institute of Science and Technology (MIST) in 2022.
    His research interest is in  Signal Processing, Brain computer interface and applied machine learning.
    
    Dewan's undergraduate project was Classification Performance Evaluation of Different Rhythmic Bands of EEG Based
    Anesthesia Monitoring
    Dewan joined the Qatar University Machine Learning Group in June 2022 as volunteer remote research assistant.
    His ongoing projects are Thinking out loud: Inner Speech Decoding from EEG data and Identification of respiratory disease from lung sound. `,
  },
  {
    id: 21,
    name: "Sidra Gul",
    member: "current",
    role: "student",
    subrole: "PhD Student",
    image: emptyImage,
    contact: "engr.sidracse@gmail.com",
    details: `Sidra Gul received the B.Sc. and MSc. degrees in Computer Systems Engineering from the University of Engineering and Technology (UET) Peshawar, Pakistan, in 2010 and 2014. She was a lab engineer in the Department of Computer Systems Engineering UET Peshawar, from 2013 to 2016. Since 2019 she is working as a Ph.D. research student within Artificial Intelligence in Healthcare, Intelligent Information Processing Lab, National Centre of Artificial Intelligence, UET Peshawar. Her research interests include Artificial Intelligence, image processing, Pattern recognition and machine learning.
    `,
  },
  {
    id: 22,
    name: "Maymouna M. Ezeddin",
    member: "lab_alumni",
    role: "researcher",
    subrole: "full time",
    image: emptyImage,
    contact: "Maymouna.ezeddin@gmail.com",
    details: `Maymouna M. Ezeddin received her Master of Science degree in Data science and Engineering from Hamad Bin Khalifa University, Qatar, 2022. She graduated with honor from her Bachelor of Science in Electrical Engineering from Qatar university, Qatar, 2020. Her research focus on applied machine learning and signal processing includes predictive analytics for health, as well as security related problems, such as the development of robust predictive models for the early detection of diabetes, and estimation of blood pressure. In the area of machine learning and security, Maymouna works on the development of AI-based models for the detection of malicious or compromised users within smart grid network.`,
  },
  {
    id: 23,
    name: "Purnata Saha",
    member: "current",
    role: "researcher",
    subrole: "volunteer researcher",
    image: image27,
    contact: "purnatasaha.1999@gmail.com",
    details: `Purnata Saha is currently pursuing her B.Sc in Electrical and Electronic Engineering, University of Dhaka. Her area of interest in research is signal processing and applied machine learning. She has already worked on some applied data science projects like vehicle detection using image, human locomotion and transportation recognition from radio data, food packaging activity using mocap sensor data`,
  },
  {
    id: 24,
    name: "MD Ahasan Atick Faisal",
    member: "current",
    role: "researcher",
    subrole: "full time",
    image: image21,
    contact: "atick.faisal@qu.edu.qa",
    linkedIn: "https://www.linkedin.com/in/atick-faisal/",
    personalWebsite: "https://atick.dev",
    github: "https://github.com/atick-faisal",
    details: `Md. Ahasan Atick Faisal received his Bachelor of Science degree in Electrical and Electronic Engineering in 2020 from the University of Dhaka, Bangladesh. His research interests include Gait Analysis, Sign Language Recognition (SLR), and Applied Machine Learning. Atick also has experience in Internet of Things (IoT) based solutions, Mobile Application Development, and MLOps. 

    Atick's undergraduate project was a sensor-based Sign Language Recognition system involving embedded systems, IoT, and Machine Learning. He also developed a novel technique for sign language recognition using Spatial Projection Images. After graduation, He worked as a Software Engineer at Leveor Inc. in the Mobile Application Development division.
    
    Atick joined the Qatar University Machine Learning Group in May 2021. There he worked on multiple Gait Analysis problems such as Neurodegenerative Diseases (NDD) detection from the Ground Reaction Force (GRF) and analyzing the effect of Tai Chi exercise on walking gait. He has proposed a low-cost alternative for accurately measuring GRF and Moment signals from walking kinematics. He also deployed several Machine Learning pipelines in mobile devices to predict glucose levels from the PPG signal, detect anomalies in the ECG Signal, and more. Additionally, he worked on an IoT-enabled automated IV dispenser system for burn patients.`,
  },
  {
    id: 25,
    name: "Sakib Mahmud",
    member: "current",
    role: "researcher",
    subrole: "full time",
    altRole: "student",
    altSubrole: "MSc Student",
    image: image22,
    contact: "sakib.mahmud@qu.edu.qa",
    github: "https://github.com/Sakib1263",
    linkedIn: "https://www.linkedin.com/in/sm1512633/",
    details: `Sakib Mahmud received his Bachelor of Science (BSc.) degree in Electrical Engineering with an Honors from Qatar University (QU) in June 2020 and currently pursuing his Master of Science (MSc.) in Electrical Engineering from the same department. As an undergraduate student, he received the Dean’s Award for six semesters during 2016-2019. As an undergraduate student at QU, He has been a part of two Undergraduate Research Experience Program (UREP) projects funded by the Qatar National Research Fund (QNRF). Upon graduation, he joined QU’s master’s program to pursue a postgraduate degree in electrical engineering and work as a Graduate Research Assistant (GRA) at the same time, under the same department. As a GRA,  and a member of QU Machine Learning Group, he was hired in two QNRF funder National Priorities Research Program (NPRP) grants and three High Impact grant from QU. Currently he is hired in a High Impact grant funded by QU. Apart from his research work, he has been an Electrical Engineering Intern in the Electrical Consultant Group (E.C.G.) Qatar Branch, Data Science Intern in Data Glacier and has been selected as an Artificial Intelligence (AI) Intern in AI Ready Academy, a joint training program for Machine Learning and Data Science by Microsoft and ZAKA, among 2000 competitive applicants around the Middle East and North Africa (MENA) region, He has expertise in Electronics Circuitry design, 3D Modeling, Biomedical Signal and Image Processing, Computer Vision, Machine and Deep Learning, and Data Analytics and Visualization in various platforms. Currently, so far, he has published 10 articles in peer reviewed Journals, one conference paper and one patent, many under review, thus accumulating around 60 citations in Google Scholar.`,
  },
  {
    id: 26,
    name: "Tawsifur Rahman",
    member: "lab_alumni",
    role: "student",
    subrole: "MSc Student",
    altRole: "researcher",
    altSubrole: "full time",
    image: image23,
    contact: "tawsifurrahman.1426@gmail.com",
    linkedIn: "https://www.linkedin.com/in/tawsifurrahman",
    googleScholar:
      "https://scholar.google.com/citations?user=Qv3rubEAAAAJ&hl=en",
    details: `Tawsifur Rahman is currently working as a research assistant in the machine learning group, Qatar University. He received his B.Sc. degree in Electrical and Electronic Engineering from University of Chittagong (Bangladesh), and M.Sc. degree in Biomedical Engineering from University of Dhaka (Bangladesh). His research interests include medical image analysis, big clinical data processing, computer vision, and deep learning. He is the author and co-author of about 30+ research journal articles, and a few book chapters on medical imaging, and clinical bio-markers data using artificial intelligence. Thus far, his publications have been cited 1600+ times (Source: Google Scholar). He has received 'ICT fellowship 2019-2020' from Information Communication & Technology (ICT) ministry of Bangladesh for his research. Moreover, he and his research team have received 'Kaggle COVID-19 dataset award' from Kaggle community.`,
  },
  {
    id: 27,
    name: "Mohamed Abdelmoniem",
    member: "current",
    role: "researcher",
    subrole: "full time",
    image: image24,
    contact: "ma1707821@qu.edu.qa",
    details: `Mohammed Abdelmoniem received his B.Sc. degree in electrical engineering with a minor in computer science from Qatar University, Qatar in 2022. He is currently working as a Research Assistant at Hamad Medical Corporation (HMC)-Medical Research Center. His research interests include signal processing and machine learning.`,
  },
  {
    id: 28,
    name: "Tasmir Ahmed",
    member: "current",
    role: "researcher",
    subrole: "full time",
    image: image25,
    contact: "tasmir-9th-2019711720@bpt.du.ac.bd",
    linkedIn: "https://www.linkedin.com/in/tasmir-ahmed-6b2219183/",
    details: `Tasmir Ahmed currently is a student at the University of Dhaka, pursuing his MS in Biomedical Physics and Technology. He received his B.Sc. in Biomedical Engineering from Military Institute of Science and Technology. His undergraduate thesis title was- "Implementation of ambucycle based emergency medical response". Tasmir has been a part of Qatar University Machine Learning Group since may, 2022. His research domain of interest is biomedical data science.`,
  },
  {
    id: 29,
    name: "Zakaria Shams Siam",
    member: "current",
    role: "researcher",
    subrole: "full time",
    altRole: "student",
    altSubrole: "MSc Student",
    image: image26,
    contact: "zaksiam101@gmail.com",
    linkedIn: "https://www.linkedin.com/in/zakaria-siam",
    personalWebsite: "https://sites.google.com/view/zssiam",
    googleScholar:
      "https://scholar.google.com/citations?user=LFJnMzUAAAAJ&hl=en&authuser=1",
    details: `Zakaria Shams Siam received the degree of Bachelor of Science with a Major in Computer Science and Engineering and a Minor in Mathematics from the Department of Electrical and Computer Engineering at North South University, Bangladesh. Currently, he is working as a full time Lecturer at Presidency University, Bangladesh. He joined Qatar University Machine Learning Group in July 2022. His current research interests are artificial intelligence and machine learning with a special focus on medical image processing. He has published several international journal and conference articles. He has previously worked as an undergraduate research assistant under the supervision of Professor Dr Rashedur M. Rahman from the Department of Electrical and Computer Engineering and Dr Zaid Bin Mahbub from the Department of Mathematics and Physics at North South University. Besides, he has performed responsibilities as an undergraduate teaching assistant in the Department of Mathematics and Physics at North South University.`,
  },
  {
    id: 30,
    name: "Amith Khandakar",
    member: "current",
    role: "student",
    subrole: "PhD Student",
    image: image28,
    contact: "amith@gmail.com",
    details: `AMITH KHANDAKAR received the B.Sc. degree in electronics and telecommunication engineering from North South University, Bangladesh, and the master’s degree in computing (networking concentration) from Qatar University, in 2014. He graduated as the Valedictorian (President Gold Medal Recipient) of North South University. He is an IEEE Senior Member. He is also a certified Project Management Professional and the Cisco Certified Network Administrator. He has 2 patents and  published around 60 peer-reviewed journal articles, conference papers, and four book chapters. His current research interests include biomedical instrumentation, wearable sensors, medical image analysis, machine learning and Engineering Education. He is also running  UREP grants from QNRF and internal grants from Qatar University.
    `,
  },
  {
    id: 31,
    name: "A.H.M Nazmus Sakib",
    member: "current",
    role: "researcher",
    subrole: "volunteer researcher",
    image: image29,
    contact: "nazmussakib2970@gmail.com",
    details: `A.H.M Nazmus Sakib is currently pursuing his B.Sc in Electrical and Electronic Engineering, University of Dhaka. His area of interest in research is signal processing, human activity detection (HAR), and healthcare technologies. He has worked as an RA for several months at FabLabDU. He achieved several national and international prizes in competitions like Bento Packaging Activity Recognition Challenge, Techkriti ML Hackathon, and Nurse Care Activity Recognition Challenge.
    `,
  },
  {
    id: 32,
    name: "Johayra Prithula",
    member: "current",
    role: "researcher",
    subrole: "full time",
    image: image30,
    contact: "prithulajohayra@gmail.com",
    github: "https://github.com/JohayraPrithula",
    linkedIn: "https://www.linkedin.com/in/johayraprithula/",
    details: `Johayra Prithula received B.Sc. (Hons. ) from the Department of Electrical and Electronics Engineering, University of Dhaka in 2022. Her undergrad thesis was on Facial Recognition based smart door lock system using transfer learning. Her primary field of research interest is applied machine learning in computer vision and their inter-disciplinary applications to biometric 
    security.
    `,
  },
  {
    id: 33,
    name: "Saidul Kabir",
    member: "current",
    role: "researcher",
    subrole: "full time",
    image: image31,
    contact: "kabirsaidul116@gmail.com",
    details: `Saidul Kabir received B.Sc. (Hons. ) from the Department of Electrical and Electronics Engineering, University of Dhaka in 2022. His undergrad thesis was recognition of human activities based on smartphone sensor data using CNN and LSTM based models. His research interests are in the field of artificial intelligence and computer vision.`,
  },
  {
    id: 34,
    name: "Sriman Bidhan Baray",
    member: "current",
    role: "researcher",
    subrole: "full time",
    image: image32,
    contact: "bidhanbaray@gmail.com",
    linkedIn: "https://www.linkedin.com/in/srimanbidhanbaray/",
    github: "https://github.com/bidhanbaray",
    personalWebsite: "https://bidhanbaray.github.io",
    details: `Sriman Bidhan Baray is an undergraduate (final year) student in Electrical and Electronic Engineering, University of Dhaka. His research interests are applied machine learning, biomedical instrumentation, computer vision, image processing, activity recognition and robotics.
    He is doing his undergraduation thesis on reading detection from EOG signals in the wild. He worked as a Part-time Engineer in Datasoft Manufacturing and Assembly Inc. for nine months where he worked with the biomedical team to design and develop different IoT based projects.`,
  },
  {
    id: 35,
    name: "Naima Nasrin Nisha",
    member: "current",
    role: "student",
    subrole: "MSc Student",
    altRole: "researcher",
    altSubrole: "volunteer researcher",
    image: image33,
    contact: "naima.nisha27@gmail.com",
    googleScholar:
      "https://scholar.google.com/citations?user=f9Wt030AAAAJ&hl=en&oi=ao",
    linkedIn: "https://www.linkedin.com/in/naima-nisha-625a3b151/",
    details: `Naima Nasrin Nisha received her B.Sc. degree from Shahjalal University of Science and Technology on Electrical and Electronic Engineering. Currently, she is pursuing her M.S. on Biomedical Physics and Technology at the University of Dhaka. During her undergrad thesis, she worked with performance evaluation of Silicon Nanowire Transistors with analog and mixed signal analysis. She has also worked with transistor-based biosensors modeling. The application of electronic devices on medical science has sparked her interest in the Biomedical field. Naima joined the Qatar University Machine Learning Group in July, 2022. In this group, she is currently working on the Transcranial Doppler Ultrasound project under the supervision of Dr. Muhammad E.H. Chowdhury. `,
  },
  {
    id: 36,
    name: "Dr. Enamul Hoque Bhuiyan",
    member: "current",
    role: "researcher",
    subrole: "volunteer researcher",
    image: image34,
    contact: "example@gmail.com",
    details: `Enamul H. Bhuiyan born and grew up at Feni in Bangladesh. He went to school there and moved to the capital city Dhaka and was admitted to Notre Dame College. He received a Ph.D. degree in physics from the Nottingham University, UK, an M.Sc. degree in physics from Laurentian University, Canada, a B.Sc. degree in physics, from the University of Dhaka. Currently, he is working as a Postdoctoral fellow in Diagnostic, Molecular and Interventional Radiology in the Department of Radiology, the BioMedical Engineering and Imaging Institute, Icahn School of Medicine at Mount Sinai. Here, he is working on body imaging, mostly on liver imaging such as DCE-MRI, DWI and motion robust liver imaging and liver cancer, particularly, hepatocellular carcinoma (HCC).
    From 2018 to 2020, he worked as Postdoctoral Associate in the Department of Radiology and Biomedical Imaging, Yale School of Medicine. Here, he worked on developing new methods in MRI, MR pulse sequence, including image encoding with nonlinear gradients and novel contrast mechanisms as well as different methods of image reconstruction. He did a bit of work on DWI to diagnose prostate cancer here in the Yale school of Medicine. His research focuses on the development of new methods (hardware and software) and their applications for biomedical imaging by using Physics and Mathematics. Moreover, He is interested in modern image reconstruction techniques and image analysis to understand brain physiology and functions, also interested in using these as a biomarker of neurological diseases and disorders. 
    `,
  },
  {
    id: 37,
    name: "Farhana Ahmed Chowdhury",
    member: "current",
    role: "student",
    subrole: "MSc Student",
    altRole: "researcher",
    altSubrole: "volunteer researcher",
    image: image35,
    contact: "fachowdhury1995@gmail.com",
    details: `Farhana Ahmed Chowdhury is currently pursuing her M.Sc. Engineering in Rajshahi University of Engineering and Technology (RUET), Bangladesh. Besides, she is also working as a professional web designer. She received her B.Sc. in Electronic and Telecommunication Engineering from Pabna University of Science and Technology (PUST). Her undergraduate thesis work was on designing a photonic crystal fiber biosensor based on surface plasmon resonance.`,
  },
  {
    id: 38,
    name: "Jawad Habib",
    member: "current",
    role: "researcher",
    subrole: "volunteer researcher",
    image: image36,
    contact: "jh.jawadhabib@gmail.com",
    linkedIn: "https://www.linkedin.com/in/jawad-habib",
    details: `Farhana Ahmed Chowdhury is currently pursuing her M.Sc. Engineering in Rajshahi University of Engineering and Technology (RUET), Bangladesh. Besides, she is also working as a professional web designer. She received her B.Sc. in Electronic and Telecommunication Engineering from Pabna University of Science and Technology (PUST). Her undergraduate thesis work was on designing a photonic crystal fiber biosensor based on surface plasmon resonance.`,
  },
  {
    id: 39,
    name: "Mohammad Kaosar Alam",
    member: "current",
    role: "student",
    subrole: "MSc Student",
    image: image37,
    contact: "example@gmail.com",
    details: `Mohammad Kaosar Alam, has completed his Bachelor of Science in Electrical & Electronic Engineering from Chittagong University of Engineering & Technology (Bangladesh). During his undergraduate stint, he worked in the field of robotics, electronics circuit design, biomedical instrumentation etc. He has proven track record of working in industrial sector in the field of electromechanical system design, installation & commissioning. 
    An enthusiast of Machine Learning, AI & Biomedical Engineering, he is now working under the auspices of the Dr. Enamul H. Chowdhury-Assistant Professor, Department of Electrical Engineering, Qatar University.
    `,
  },
];

export default listOfTeamMembers;
